import { llmCategorizationStateSchema, llmChatMessageSchema } from '@teo/types';
import { z } from 'zod';
export { llmChatMessageSchema };
export const MAX_FILE_SIZE = 50 * 1024 * 1024;
export const FILE_TYPES = {
    'application/pdf': '.pdf',
    'image/jpeg': '.jpeg',
    'image/png': '.png',
};
export const ALLOWED_FILE_MIME_TYPES = Object.keys(FILE_TYPES);
export const isPdfMimeType = (type) => type === 'application/pdf';
export const isImageMimeType = (type) => type === 'image/jpeg' || type === 'image/png';
export const documentKindForMime = (type) => {
    if (isPdfMimeType(type))
        return 'pdf';
    if (isImageMimeType(type))
        return 'image';
    return 'other';
};
export const displayId = z
    .string()
    .describe('A TEOAI display id: a four-letter prefix, then eight characters. Never send a numeric row id. The field name says what kind of thing it identifies.');
export const singleCategorizationSchema = z
    .object({
    status: llmCategorizationStateSchema.nullable(),
    category: z.string().optional(),
    metadata: z.record(z.string(), z.any()).optional(),
})
    .optional();
export const documentCategorizationSchema = z
    .object({
    primary: singleCategorizationSchema,
    secondary: singleCategorizationSchema,
})
    .optional();
export const successResponseSchema = z.object({
    success: z.boolean(),
});
export const successResponseWithMessageSchema = successResponseSchema.extend({
    message: z.string(),
});
export const entityInputSchema = z
    .discriminatedUnion('type', [
    z.object({
        type: z.literal('ownership'),
        ownershipId: displayId.describe('An ownership display id, such as OWNDR4T5Y6U8.'),
    }),
    z.object({
        type: z.literal('portfolio'),
        portfolioId: displayId.describe('A portfolio display id, such as PORTJ7K8M9N2.'),
    }),
    z.object({
        type: z.literal('property'),
        propertyId: displayId.describe('A property display id, such as PROPQ3R4S5T6.'),
    }),
])
    .describe('The ownership, portfolio or property the question is about. Send the smallest one that answers the question. Set `type` to match the id you send.');
export const scheduleEntitySchema = z
    .discriminatedUnion('type', [
    ...entityInputSchema.options,
    z.object({
        type: z.literal('unit'),
        unitId: displayId.describe('A unit display id, such as UNITK4M5N6P7.'),
    }),
])
    .describe('The ownership, portfolio, property or unit the schedule belongs to. Set `type` to match the id you send.');
export const entityOutputSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('ownership'),
        ownershipId: displayId,
        name: z.string(),
        isAssociation: z.boolean(),
    }),
    z.object({
        type: z.literal('portfolio'),
        portfolioId: displayId,
        name: z.string(),
    }),
    z.object({
        type: z.literal('property'),
        propertyId: displayId,
        name: z.string(),
    }),
]);
//# sourceMappingURL=common.js.map